import { lockScroll } from './lockScroll.js';

var sitewide = {},
		open = false,
		busy = false;

sitewide.init = function() {
	$('#menu-button').click(function(e) {
		e.preventDefault();
		var $btn = $(this),
				$menu = $('#sitewide .menu');
		if (busy == false) {
			busy = true;
			if (open == false) {
				open = true;
				$btn.addClass('is-active');
				$menu.addClass('is-active');
				lockScroll.init(true);
				setTimeout(function() {
					$menu.addClass('animate-in');
					busy = false;
				}, 100);
			} else {
				open = false;
				$btn.removeClass('is-active');
				$menu.removeClass('animate-in');
				lockScroll.init(false);
				setTimeout(function() {
					$menu.removeClass('is-active');
					busy = false;
				}, 500);
			}
		}
	})
}

export { sitewide };
